import React, { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

/** Bottom banner "Installa app" quando il browser supporta beforeinstallprompt. */
export const InstallPrompt = () => {
  const [deferred, setDeferred] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("guzz_install_dismissed") === "1") {
      setDismissed(true);
      return;
    }
    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    const choice = await deferred.userChoice;
    if (choice.outcome === "accepted") {
      setDeferred(null);
    }
  };

  const dismiss = () => {
    localStorage.setItem("guzz_install_dismissed", "1");
    setDismissed(true);
  };

  if (!deferred || dismissed) return null;
  return (
    <div
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-sm z-50 bg-midnight text-white p-5 border border-gold/50 shadow-2xl"
      data-testid="install-prompt"
    >
      <button
        onClick={dismiss}
        className="absolute top-2 right-2 p-1 text-white/50 hover:text-white"
        aria-label="Chiudi"
        data-testid="install-dismiss"
      >
        <X size={16} />
      </button>
      <h3 className="font-display text-lg text-gold mb-1">Installa l'app</h3>
      <p className="text-sm text-white/70 leading-relaxed mb-4">
        Aggiungi Guzzardella Auto alla schermata Home per accedervi con un tap.
      </p>
      <button
        onClick={install}
        className="btn-gold w-full flex items-center justify-center gap-2 py-2.5 text-xs uppercase tracking-widest font-semibold"
        data-testid="install-btn"
      >
        <Download size={13} /> Installa
      </button>
    </div>
  );
};

export default InstallPrompt;
